export default {
  categories (state) {
    return state.categories
  },
  allowedCategoriesForScheduled (state) {
    return state.allowedCategoriesForScheduled
  },
  payments (state) {
    return state.payments
  },
  families (state) {
    return state.families
  }
}



// WEBPACK FOOTER //
// ./src/store/detalheCadastro/getters.js